import { render, staticRenderFns } from "./UploadExcel.vue?vue&type=template&id=20bb471e&scoped=true&"
import script from "./UploadExcel.vue?vue&type=script&lang=js&"
export * from "./UploadExcel.vue?vue&type=script&lang=js&"
import style0 from "./UploadExcel.vue?vue&type=style&index=0&id=20bb471e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb471e",
  null
  
)

export default component.exports